import React from "react";
import withView from '../../cmn/docAutomation/withView';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel'
import FormTitle from '../../../library/form/components/FormTitle';
import FormSH from '../../../library/form/components/FormSH';
import FormWrapper from '../../../library/form/components/FormWrapper';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColOne, UiCol } from "../../../library/layout/Index";

const InvTrnHeaderEmbEditor = (props) => {
    const { formObject } = props;
    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Transaction Details' />
                    </span>
                </UiTitle>

                <UiAction>
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionIconButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "transCat2" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transCat2" }} value="Category" />
                                </span>
                                <FormInput autofocus formObject={formObject} rowKey="" className="uiInput"
                                    action={{
                                        InputType: "ac", paramName: "transCat2", acMethod: "CategoryDetail",
                                        acDepCtrl: { dparam: '%dataList.valLCat' }
                                    }}
                                />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profileName" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileName" }} value="Customer" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{
                                        InputType: "ac", paramName: "profileName", acMethod: "ProfileName", actionId: "refresh", refreshMode:"dep", actionParam: { updateProfile: 1, viewCaller:"embedded" },
                                        acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 }
                                    }}
                                />
                                <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "profileSHEditContainer" }} >
                                    <FormSH formObject={formObject} rowKey="" 
                                        action={{ actionId: "edit", paramName: "profileName",  actionName: "proComp", actionParam: {}, containerKey: "popup" }}
                                    ></FormSH>
                                </FormWrapper>
                                <FormSH formObject={formObject} rowKey="" action={{
                                    actionId: "new", paramName: "profileName", 
                                    actionName: "proComp", actionParam: {}, containerKey: "popup"
                                }} >
                                </FormSH>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "fromLoc" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "fromLoc" }} value="From Location" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "ac", paramName: "fromLoc", actionId: "refresh", acMethod: "Location",
                                    actionParam: { viewCaller:"embedded" } }}
                                />
                            </FormWrapper >
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "toLoc" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "toLoc" }} value="To Location" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "ac", paramName: "toLoc", actionId: "refresh", acMethod: "Location",
                                    actionParam: { viewCaller:"embedded" } }} />
                            </FormWrapper>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transCat" }} value="Category" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "ac", paramName: "transCat", actionId: "refresh", 
                                    actionParam: { viewCaller:"embedded" }, acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "inchrgUser" }} value="Incharge User" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "ac", paramName: "inchrgUser", acMethod: "UserNames",
                                    actionId: "refresh", actionParam: { viewCaller:"embedded" } }} />
                            </li>
                        </ul >

                        <ul>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "deliverAdd" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "deliverAdd" }} value="Delivery Address" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "input", paramName: "deliverAdd", 
                                    actionId: "refresh", actionParam: { viewCaller:"embedded" } }} />
                            </FormWrapper>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comments" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "input", paramName: "comment",
                                    actionId: "refresh", actionParam: { viewCaller:"embedded" } }} />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "refExNo" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refExNo" }} value="Ref. No (Ex)" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "input", paramName: "refExNo",
                                    actionId: "refresh", actionParam: { viewCaller:"embedded" } }} />
                            </FormWrapper>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refInNo" }} value="Ref. No (In)" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "input", paramName: "refInNo",
                                    actionId: "refresh", actionParam: { viewCaller:"embedded" } }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "transdate" }} value="Document Date" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className=""
                                    action={{ InputType: "dp", paramName: "transdate",
                                    actionId: "refresh", actionParam: { viewCaller:"embedded" } }} />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "reqbydate" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reqbydate" }} value="Required On" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className=""
                                    action={{ InputType: "dp", paramName: "reqbydate",
                                    actionId: "refresh", actionParam: { viewCaller:"embedded" } }} />
                            </FormWrapper>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>
        </UiView >
    )
}

export default withView(InvTrnHeaderEmbEditor, "invTrnHeader", "invTrnHeader,docAttributeValue,invTrnTerms,invTrnTracker")